import { COLORS_MAP } from '../config';
import { IMotivationGoalPrepared } from '../interfaces';

interface ILineProps {
    target: IMotivationGoalPrepared['level'];
    progress: number;
    isFirst: boolean;
    isLast: boolean;
}

const Line: React.FC<ILineProps> = ({ target, progress, isFirst, isLast }) => {
    const roundedClassName = [isFirst && 'rounded-l-3', isLast && 'rounded-r-3']
        .filter(Boolean)
        .join(' ');

    return (
        <div
            className={`w-full h-[16px] overflow-hidden ${roundedClassName}`}
            style={{
                backgroundColor: isLast ? COLORS_MAP[3].secondary : COLORS_MAP[target].secondary,
            }}
        >
            <div
                className="h-[16px]"
                style={{
                    width: `${progress}%`,
                    backgroundColor: isLast ? COLORS_MAP[3].primary : COLORS_MAP[target].primary,
                }}
            />
        </div>
    );
};

export default Line;
